const STORAGE_KEY = "conciergie_last_qr";

export interface LastQrPayload {
  pngDataUrl: string;
  targetUrl: string;
  savedAt?: string;
}

const isBrowser = typeof window !== "undefined";

export async function saveLastQr(pngUrl: string, targetUrl: string): Promise<void> {
  if (!isBrowser) return;
  try {
    let pngDataUrl = pngUrl;

    // If we already have a data URL, reuse it directly.
    if (!pngUrl.startsWith("data:")) {
      const response = await fetch(pngUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch QR PNG: ${response.status}`);
      }
      const blob = await response.blob();

      pngDataUrl = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (typeof reader.result === "string") {
            resolve(reader.result);
          } else {
            reject(new Error("Failed to convert QR PNG to data URL"));
          }
        };
        reader.onerror = () => reject(new Error("Failed to read QR PNG blob"));
        reader.readAsDataURL(blob);
      });
    }

    const payload: LastQrPayload = {
      pngDataUrl,
      targetUrl,
      savedAt: new Date().toISOString(),
    };

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // Best-effort only: if persistence fails, do not break the flow.
  }
}

export function loadLastQr(): LastQrPayload | null {
  if (!isBrowser) return null;

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as Partial<LastQrPayload> | null;
    if (!parsed || typeof parsed.pngDataUrl !== "string" || typeof parsed.targetUrl !== "string") {
      return null;
    }

    return {
      pngDataUrl: parsed.pngDataUrl,
      targetUrl: parsed.targetUrl,
      savedAt: typeof parsed.savedAt === "string" ? parsed.savedAt : undefined,
    };
  } catch {
    return null;
  }
}


